import { Grid, Box, Button, IconButton } from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { FormSelect } from "../form-elements/FormSelect";
import { FormTextField } from "../form-elements/FormTextField";

export const IncorrectInfoForm = ({
  formData,
  handleChange,
  entries,
  handleEntryChange,
  addNewEntry,
  removeEntry,
  generalMessage,
  handleGeneralMessageChange,
}) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <FormTextField
          label="Full Name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          required
          placeholder="Full Name"
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <FormTextField
          label="Email"
          name="email"
          type="email"
          value={formData.email}
          onChange={handleChange}
          required
          placeholder="Enter your email so we can reach you if needed"
        />
      </Grid>

      {entries.map((entry, index) => (
        <Grid item xs={12} key={entry.id}>
          <Box
            sx={{
              p: 4,
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              position: "relative",
            }}
          >
            {entries.length > 1 && (
              <IconButton
                onClick={() => removeEntry(entry.id)}
                sx={{
                  position: "absolute",
                  top: 1,
                  right: 1,
                  color: "error.main",
                }}
              >
                <Delete />
              </IconButton>
            )}

            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormSelect
                  label="What type of information is incorrect?"
                  name="errorType"
                  value={entry.errorType || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  options={[
                    { value: "Enumber", label: "E-Number" },
                    { value: "Restaurant", label: "Restaurant" },
                    { value: "Mosque", label: "Mosque" },
                  ]}
                  required
                />
              </Grid>

              <Grid item xs={12}>
                <FormTextField
                  label="Location/Name"
                  name="location"
                  value={entry.location || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  required
                  placeholder="Name or location of the place"
                />
              </Grid>

              <Grid item xs={12}>
                <FormTextField
                  label="Why do you think it is incorrect?"
                  name="subject"
                  value={entry.subject || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  multiline
                  rows={3}
                  required
                  placeholder="Share your reason for thinking this is incorrect"
                />
              </Grid>

              <Grid item xs={12}>
                <FormTextField
                  label="Correct information"
                  name="correctInfo"
                  value={entry.correctInfo || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  multiline
                  rows={3}
                  required
                  placeholder="What should the correct info be?"
                />
              </Grid>

              <Grid item xs={12}>
                <FormTextField
                  label="URL of incorrect field (optional)"
                  name="url"
                  value={entry.url || ""}
                  onChange={(e) => handleEntryChange(e, index)}
                  placeholder="Link to the page with the issue (if any)"
                />
              </Grid>
            </Grid>
          </Box>
        </Grid>
      ))}

      <Grid item xs={12}>
        <Button
          variant="outlined"
          startIcon={<Add />}
          onClick={addNewEntry}
          sx={{
            color: "#00171f",
            borderColor: "#00171f",
            "&:hover": {
              backgroundColor: "#00171f",
              color: "#fff",
              borderColor: "#00171f",
            },
            borderRadius: 2,
            padding: "7px 10px",
            fontSize: "1rem",
            boxShadow: "none",
            width: "auto",
            mt: 3,
          }}
        >
          Add Another Incorrect Information
        </Button>
      </Grid>

      <Grid item xs={12}>
        <FormTextField
          label="Message for us (optional)"
          name="generalMessage"
          value={generalMessage}
          onChange={handleGeneralMessageChange}
          multiline
          rows={3}
          fullWidth
          placeholder="Write your message here..."
        />
      </Grid>
    </Grid>
  );
};
